import type { RouteRecordRaw } from 'vue-router'
import routerNames from './routerNames'
import routerTitle from './RouterTitle'
import breadcrumbName from './breadcrumbName'

const PortfolioRouter: RouteRecordRaw = {
  path: '/',
  meta: {
    requiresAuth: true,
    breadcrumb: breadcrumbName.PORTFOLIO
  },
  component: () => import('@/layouts/DefaultLayout.vue'),
  children: [
    {
      name: routerNames.PORTFOLIO,
      path: 'portfolio',
      component: () => import('@/views/Portfolio/PortfolioView.vue'),
      meta: {
        title: routerTitle.PORTFOLIO,
        breadcrumb: breadcrumbName.PORTFOLIO
      }
    }
  ]
}

export default PortfolioRouter
